import React from 'react';

import type { Share } from '../../types/share';

const DashboardShareItem: React.FC<{ share: Share }> = ({ share }) => {
  const firstView = share.views[0]?.created_at || 'never';
  return (
    <tr>
      <td className="dashboard-share-email">{share.email}</td>
      <td className="dashboard-share-name">{share.name}</td>
      <td className="dashboard-share-comment">{share.comment}</td>
      <td className="dashboard-share-sent-at">{share.sent_at}</td>
      <td className="dashboard-share-first-view">{firstView}</td>
    </tr>
  );
}

export default DashboardShareItem;
